import axios from "axios";

export default {
  async add(pago) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    try {
      const result = await axios.post("api/renta-pago", pago, headerAuth);
      return result.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async update(pago) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    try {
      const result = await axios.put(
        `api/renta-pago/${pago.numPago}`,
        pago,
        headerAuth
      );
      return result.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  delete(rentaId, numPago) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .delete(`api/renta-pago/${rentaId}/${numPago}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  getPagos(rentaId) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/renta-pagos/${rentaId}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  getPago(rentaId, numPago) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/renta-pago/${rentaId}/${numPago}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
